/** Feeds the workspace's "Frequently used" emoji (EmojiUsageViewModel) to every emoji picker and hover bar inside. */
import { useMemo, useSyncExternalStore, type ReactNode } from "react";
import { FrequentEmojiContext, type FrequentEmoji } from "../primitives/index.ts";
import { useT } from "../i18n/I18nProvider.tsx";
import { useEmojiUsage } from "./registry.ts";

const noSubscribe = () => () => {};

export function FrequentEmojiProvider({ children }: { children: ReactNode }) {
  const t = useT();
  const usage = useEmojiUsage();
  const emoji = useSyncExternalStore(usage?.subscribe ?? noSubscribe, () => usage?.state.frequent);
  const skinTone = useSyncExternalStore(usage?.subscribe ?? noSubscribe, () => usage?.state.skinTone);
  const value = useMemo<FrequentEmoji | null>(
    () =>
      usage === undefined || emoji === undefined
        ? null
        : {
            emoji,
            label: t("picker.emoji.frequent"),
            onUse: (e, report) => usage.use(e, report),
            skinTone: skinTone ?? "none",
            onSkinTone: (tone) => usage.setSkinTone(tone),
            skinToneLabel: t("picker.emoji.skinTone"),
          },
    [usage, emoji, skinTone, t],
  );
  return <FrequentEmojiContext.Provider value={value}>{children}</FrequentEmojiContext.Provider>;
}
